import styled, { css } from 'styled-components'

const iconType = ({ type }) => {
  if (type === 'confirmed') {
    return css`
      background-color: rgba(5, 148, 79, 0.1);

      path {
        fill-opacity: 1;
        fill: rgba(5, 148, 79, 1);
      }
    `
  } else if (type === 'rejected') {
    return css`
      background-color: rgba(225, 25, 0, 0.1);

      path {
        fill-opacity: 1;
        fill: rgba(225, 25, 0, 1);
      }
    `
  }
}

export const AssessmentPageTittleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: ${(p) => {
    if (p.hasCriteriaSummary && p.firstTitle) {
      return '32px'
    }
    return p.firstTitle ? '168px' : '96px'
  }};
  margin-bottom: ${(p) => {
    return p.marginBottom? p.marginBottom : '0px'
  }};
`

export const AssessmentPageTittle = styled.div`
  line-height: 32px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 8px;
`

export const AssessmentPageSubTittle = styled.div`
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
  border-bottom: 2px dotted rgba(32, 32, 32, 0.5);
`

export const AssessmentPageSubTittleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${(p) => {
    return p.marginBottom
  }};
`

export const AssessmentPageSubTittleIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
`

export const AssessmentPageNewEcosystemWrapper = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  color: #0aa1f4;
  cursor: pointer;

  > svg {
    margin-right: 8px;
  }

  path {
    fill: #0aa1f4;
  }
`

export const EcoIntegrityQualificationContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  background: rgba(32, 32, 32, 0.03);
  padding: 32px;
  margin-bottom: 64px;
`

export const CriterionCHeaderWrapper = styled.div`
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid rgba(32, 32, 32, 0.2);
  border-bottom: 1px solid rgba(32, 32, 32, 0.2);
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  cursor: pointer;
  margin-bottom: 64px;
`

export const CriterionCHeaderIconWrapper = styled.div`
  height: 16px;
  width: 16px;
  border-radius: 2px;  
  display: grid;
  place-items: center;
`

export const CriterionCHeaderIcon = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: ${(p) => {
    return p.nonQualified ? 'rgba(32, 32, 32, 0.5)' : '#0aa1f4'
  }};
`

export const CriterionCHeaderTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-left: 16px;
`

export const CriterionCHeaderValidationIcon = styled.div`
  position: absolute;
`

export const CriterionCHeaderValidationIconWrapper = styled.div`
  position: relative;
  left: 16px;
  
`

export const CriterionCHeaderConfirmDeclineIcon = styled.div`
  margin-right: 32px;
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  ${iconType}
`

export const CriterionCHeaderCalendarIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  margin-right: 8px;
`

export const CriterionCHeaderCalendarDivider = styled.div`
  height: 24px;
  width: 1px;
  background: rgba(32, 32, 32, 0.1);
  margin: 0 24px;
`

export const CriterionCHeaderCalendarDateText = styled.div`
  color: rgba(32, 32, 32, 0.7);
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  border-bottom: 1px dotted rgba(32, 32, 32, 0.5);

`

export const CriterionCHeaderLastReassessmentCalendarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CriterionCHalfSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CriterionCFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const CriterionCToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32, 0.7)'
  }};
  gap: 8px;

  path {
    fill: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32)'
  }};
    fill-opacity: ${(p) => {
    return p.isActive ? '1' : '0.5'
  }};
  }

  :hover {
    color: rgba(10, 161, 244, 1);

    path {
      fill-opacity: 1;
      fill: rgba(10, 161, 244, 1);
    }
  }
`

export const WrapperCheckBox = styled.div`
  display: flex;
  justify-content: space-between;
  border: 1px solid rgba(32, 32, 32, 0.2); 
  border-radius: 4px;
  padding: 12px 8px 12px 16px;
  box-sizing: border-box;
  box-shadow: 0px 1px 2px rgba(32, 32, 32, 0.05);
  margin-bottom: 32px;
  background: ${(p) => {
    return p.disabled ? 'rgb(250 250 250)' : '#FFF'
  }};
`
export const AssessmentPageLabel = styled.div`
  line-height: 32px;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 8px;
`
export const AssessmentPageLabelIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
`

export const AssessmentPageLabelWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: ${(p) => {
    return p.firstTitle ? '168px' : '96px'
  }};
  margin-bottom: ${(p) => {
    return p.marginBottom? p.marginBottom : '0px'
  }};
`
